/**
 * BLOCK: posts
 */

import Swiper, { Navigation } from "swiper";

jQuery(document).ready(function ($) {
  class OtherPostsSlider {
    constructor(sliderElement) {
      this.sliderElement = sliderElement;

      this._init();
    }

    _init() {
      this.instance = new Swiper(this.sliderElement, {
        modules: [Navigation],
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        createElements: true,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          // when window width is >= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
      });
    }
  }

  window.luther = window.luther || {};
  window.luther.otherPostsSliders = [];

  $(".other-posts__slider >.swiper").each((i, el) => {
    let sliderElement = new OtherPostsSlider(el);
    window.luther.otherPostsSliders.push(sliderElement);
  });
});
